import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { closeModal } from './modalReducer';

export default function ModalWrapper({ children, size, header }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);

  function handleClose() {
    setOpen(false);
    dispatch(closeModal());
  }

  return (
    <Modal
      open={open}
      onOpen={() => setOpen(true)}
      onClose={handleClose}
      size={size}
    >
      {header && <Modal.Header>{header}</Modal.Header>}
      <Modal.Content>{children}</Modal.Content>
    </Modal>
  );
}
